import StepPublishController from './stepPublishController';
import './stepPublish.scss';

const StepPublishComponent = {
    template: require('./stepPublishView.html'),
    controller: StepPublishController,

};

export default StepPublishComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepPublish/stepPublishComponent.js